import { defineComponent } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

import { SvgAttribute } from "@/shared/constants/constants";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    view: {
      type: String,
      default: "",
    },
    modelValue: {
      type: String,
      required: true,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    "update:modelValue": null,
  },
  computed: {
    displayedIcons(): SvgAttribute {
      return SVG;
    },
  },
  methods: {
    handleChangeValue(event: Event): void {
      const input = event.target as HTMLInputElement;
      let value = input.value;

      // Разрешаем только цифры и одну точку
      value = value.replace(/[^0-9.]/g, ""); // Удаляем все, кроме цифр и точки
      value = value.replace(/(\..*?)\..*/g, "$1"); // Удаляем все лишние точки, оставляя только одну

      // Обновляем значение
      input.value = value;
      this.$emit("update:modelValue", +value);
    },
  },
});
